module.exports = __webpack_public_path__ + "media/images/logo_pc-117121ac0d20005d35d3a9d7d1edff3c.png";